export const WA_NUMBER = "6285945169127";

export const IMAGES = {
  logoMark: "/assets/logo-mark.png",
  teamWorking: "/assets/team-working.jpg",
  teamPortrait: "/assets/team-portrait.jpg",
};

export const GALLERY = [
  {
    before: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?auto=format&fit=crop&w=900&q=80",
    after: "https://images.unsplash.com/photo-1581578731548-c64695cc6952?auto=format&fit=crop&w=900&q=80",
    title: "Dapur lebih segar",
  },
  {
    before: "https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?auto=format&fit=crop&w=900&q=80",
    after: "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?auto=format&fit=crop&w=900&q=80",
    title: "Kamar mandi kinclong",
  },
  {
    before: "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?auto=format&fit=crop&w=900&q=80",
    after: "https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?auto=format&fit=crop&w=900&q=80",
    title: "Ruang nyaman kembali",
  },
];

export const FAQS = [
  {
    q: "Apa perbedaan Reguler dan Deep Cleaning?",
    a: "Reguler Cleaning cocok untuk perawatan rutin dengan tarif Rp 60.000/jam. Deep Cleaning seharga Rp 75.000/jam untuk pembersihan lebih menyeluruh dan detail.",
  },
  {
    q: "Apakah bisa memilih gender petugas?",
    a: "Bisa. Anda dapat memilih petugas Pria atau Wanita saat mengisi form booking, sesuai kenyamanan Anda.",
  },
  {
    q: "Bagaimana kebijakan refund dan reschedule?",
    a: "Refund atau reschedule dapat dilakukan maksimal 2 jam sebelum layanan dimulai. Lewat dari waktu tersebut, dikenakan biaya transport petugas sebesar Rp 25.000. Ajukan langsung lewat tombol di bawah — pesan Anda sudah kami siapkan otomatis.",
    cta: {
      label: "Ajukan Refund / Reschedule",
      testid: "faq-refund-whatsapp-button",
      message: "Halo Antar Cleaning, saya ingin mengajukan Refund/Reschedule untuk pesanan saya.\n- Nama:\n- Tanggal layanan:\n- Alasan:\nMohon dibantu ya. Terima kasih.",
    },
  },
  {
    q: "Bagaimana jika luas rumah lebih dari 250m²?",
    a: "Kami menyarankan survey terlebih dahulu agar hasil dan estimasi lebih maksimal. Biaya survey adalah Rp 65.000 per kunjungan. Klik tombol di bawah untuk langsung request jadwal survey.",
    cta: {
      label: "Request Survey via WhatsApp",
      testid: "faq-survey-whatsapp-button",
      message: "Halo Antar Cleaning, saya ingin Request Survey untuk hunian di atas 250m2. Mohon info jadwal survey dan detailnya.",
    },
  },
];

export const formatRupiah = (value) => `Rp ${value.toLocaleString("id-ID")}`;

export const dayName = (date) =>
  date
    ? new Intl.DateTimeFormat("id-ID", { weekday: "long", day: "numeric", month: "long", year: "numeric" }).format(new Date(`${date}T00:00:00`))
    : "Belum dipilih";

const tomorrow = new Date();
tomorrow.setDate(tomorrow.getDate() + 1);
export const minBookingDate = `${tomorrow.getFullYear()}-${String(tomorrow.getMonth() + 1).padStart(2, "0")}-${String(tomorrow.getDate()).padStart(2, "0")}`;

export const staffRecommendation = (area) => {
  if (!area || area <= 0 || area > 250) return null;
  if (area <= 50) return { min: 1, max: 1 };
  if (area <= 100) return { min: 2, max: 2 };
  if (area <= 150) return { min: 3, max: 4 };
  if (area <= 200) return { min: 4, max: 5 };
  return { min: 5, max: 8 };
};
